module.exports = __webpack_public_path__ + "static/img/default.1ac08eca.png";